import { Injectable} from '@angular/core';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';
import { DatePipe } from '@angular/common';
import { SearchTableState } from "../search-table-state";
import { BaseService } from "../base.service";
import { AuditReportEntries } from "./audit-report-entries";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable()
export class AuditReportService extends BaseService {
    private static auditSiteUrl: string = '/api/audit';
    private static searchUrl: string = '/api/audit/search';
    private static exportExcelUrl: string = '/api/audit/exportExcel';
    public searchTableState: SearchTableState = null;

    constructor(
        private http: HttpClient,
        private datePipe: DatePipe
    ) {
        super();
        this.searchTableState = new SearchTableState();
    }

    private searchTableStateCopy(): any {
        let copy: any = Object.assign({}, this.searchTableState);
        /* Disable refresh search */
        copy.lastRefreshed = new Date();
        if (copy.lastRefreshed) {
            copy.lastRefreshed = new Date(copy.lastRefreshed.getTime() + -1 * (new Date().getTimezoneOffset() * 60000));
        }
        return copy;
    }

    public search(): Observable<Array<AuditReportEntries>> {
        let copy = this.searchTableStateCopy();
        return this.http.post<any>(AuditReportService.searchUrl, copy)
        .map(data => {
            let auditReportEntries: Array<AuditReportEntries> = this.dataToReportEntry(data);
            this.searchTableState.totalItems = auditReportEntries.length;
            return auditReportEntries
        });
    }

    public exportExcel(): Observable<any> {
        let copy = this.searchTableStateCopy();
        return this.http.post<any>(AuditReportService.exportExcelUrl, copy, { responseType: 'blob' as 'json' });
    }

    public dataToReportEntry(data: any): Array<AuditReportEntries> {
        let auditReportEntries = new Array<AuditReportEntries>();
        if (data == null) {
            return auditReportEntries;
        }
        for (let d of data) {
            let auditReportEntry = new AuditReportEntries();
            auditReportEntry.DbLogId = d.DbLogId;
            auditReportEntry.UserId = d.UserId;
            auditReportEntry.TableName = d.TableName;
            auditReportEntry.Identifier = d.Identifier;
            auditReportEntry.CreatedDateUtc = d.CreatedDateUtc;
            auditReportEntry.FieldName = d.FieldName;
            auditReportEntry.OldValue = d.OldValue;
            auditReportEntry.NewValue = d.NewValue;
            auditReportEntry.UpdateOrder = d.UpdateOrder;
            auditReportEntry.UpdatedBy = d.UpdatedBy;
            auditReportEntry.Action = d.Action;
            auditReportEntries.push(auditReportEntry);
        }
        return auditReportEntries;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/audit-report/audit-report.service.ts